import React, { memo } from 'react';

import { Box } from '@mui/material';
import TooltipWrapper from 'app/shared/components/common/TooltipWrapper';
import PropTypes from 'prop-types';

import { surplusContentStyles, surplusTooltipStyles } from '../../PresenceAvatarGroup.styles';
import { PresenceAvatarGroupTestIds } from '../../PresenceAvatarGroup.testIds';
import PresenceSurplusTooltipContent from '../PresenceSurplusTooltipContent';

const PresenceSurplusCount = ({ surplus, usersData }) => (
  <TooltipWrapper
    title={<PresenceSurplusTooltipContent usersData={usersData} />}
    tooltipSx={surplusTooltipStyles}
  >
    <Box data-testid={PresenceAvatarGroupTestIds.SURPLUS} sx={surplusContentStyles}>
      +{surplus}
    </Box>
  </TooltipWrapper>
);

PresenceSurplusCount.propTypes = {
  surplus: PropTypes.number.isRequired,
  usersData: PropTypes.array.isRequired,
};

export default memo(PresenceSurplusCount);
